<template>
  <template-view
    :movies="trendingMovie"
    :isLoading="isLoading.trending"
    title="Trending movies"
  />
</template>

<script>
import { onMounted, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import TemplateView from "@/components/templates/TemplateView.vue";
export default {
  name: "Trending",
  components: { TemplateView },
  setup() {
    const store = useStore();
    const route = useRoute();

    let trendingMovie = computed(() => store.state["tmdbApi"].trendingMovies);
    let isLoading = computed(() => store.state["tmdbApi"].isLoading);
    let release_btw = computed(() => store.state.release_btw);

    const fetchTrendingMovies = async (query) => {
      query = { ...query, ...release_btw.value };
      await store.dispatch("tmdbApi/trendingMovies", query);
    };

    onMounted(() => fetchTrendingMovies(route.query));

    watch(
      () => route.query,
      async (query) => await fetchTrendingMovies(query)
    );

    watch(
      () => release_btw.value,
      () => fetchTrendingMovies(route.query)
    );

    return {
      trendingMovie,
      isLoading,
    };
  },
};
</script>
